/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseDbOsiOSICoreTypes,
  ApiResponseDbRegistrationDocOSICoreTypes,
  ApiResponseDbRegistrationOSICoreTypes,
  ApiResponseIEnumerable1OSICoreModelsDbRegistrationAccountPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbRegistrationDocPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbRegistrationPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesRequiredDocsResponsePrivateCoreLib,
  ApiResponseInt32SystemPrivateCoreLib,
  ApiResponseList1OSICoreModelsResponsesAccountWithScanResponsePrivateCoreLib,
  ApiResponseList1OSICoreModelsResponsesGroupWithAccountResponsePrivateCoreLib,
  ApiResponseResponsesSfuAccountResponseOSICoreTypes,
  GetApiRegistrationsReqdocsParams,
  PutApiRegistrationsIdSignParams,
  RequestsAddScanDoc,
  RequestsRegistrationRequest,
  RequestsSfuAccountRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить список всех заявок
 */
export const getApiRegistrationsAll = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbRegistrationPrivateCoreLib>(
    { url: `/api/Registrations/all`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsAllQueryKey = () => {
  return [`/api/Registrations/all`] as const;
};

export const getGetApiRegistrationsAllQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsAll>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsAll>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsAll>>> = ({ signal }) =>
    getApiRegistrationsAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsAllQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRegistrationsAll>>>;
export type GetApiRegistrationsAllQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsAll<
  TData = Awaited<ReturnType<typeof getApiRegistrationsAll>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsAll>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsAll>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsAll<
  TData = Awaited<ReturnType<typeof getApiRegistrationsAll>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsAll>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsAll>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsAll<
  TData = Awaited<ReturnType<typeof getApiRegistrationsAll>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsAll>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список всех заявок
 */

export function useGetApiRegistrationsAll<
  TData = Awaited<ReturnType<typeof getApiRegistrationsAll>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsAll>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить данные заявки
 */
export const getApiRegistrationsId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbRegistrationOSICoreTypes>(
    { url: `/api/Registrations/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsIdQueryKey = (id: number) => {
  return [`/api/Registrations/${id}`] as const;
};

export const getGetApiRegistrationsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsId>>> = ({ signal }) =>
    getApiRegistrationsId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRegistrationsId>>>;
export type GetApiRegistrationsIdQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsId>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsId>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные заявки
 */

export function useGetApiRegistrationsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменение заявки
 */
export const putApiRegistrationsId = (
  id: number,
  requestsRegistrationRequest: BodyType<RequestsRegistrationRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Registrations/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsRegistrationRequest
    },
    options
  );
};

export const getPutApiRegistrationsIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsId>>,
    TError,
    { id: number; data: BodyType<RequestsRegistrationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationsId>>,
  TError,
  { id: number; data: BodyType<RequestsRegistrationRequest> },
  TContext
> => {
  const mutationKey = ['putApiRegistrationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRegistrationsId>>,
    { id: number; data: BodyType<RequestsRegistrationRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiRegistrationsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiRegistrationsId>>>;
export type PutApiRegistrationsIdMutationBody = BodyType<RequestsRegistrationRequest>;
export type PutApiRegistrationsIdMutationError = ErrorType<unknown>;

/**
 * @summary Изменение заявки
 */
export const usePutApiRegistrationsId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsId>>,
      TError,
      { id: number; data: BodyType<RequestsRegistrationRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiRegistrationsId>>,
  TError,
  { id: number; data: BodyType<RequestsRegistrationRequest> },
  TContext
> => {
  const mutationOptions = getPutApiRegistrationsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Удаление заявки
 */
export const deleteApiRegistrationsId = (id: number, options?: SecondParameter<typeof axiosForReactQueryInstance>) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Registrations/${id}`, method: 'DELETE' }, options);
};

export const getDeleteApiRegistrationsIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiRegistrationsId>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiRegistrationsId>>, TError, { id: number }, TContext> => {
  const mutationKey = ['deleteApiRegistrationsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiRegistrationsId>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteApiRegistrationsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRegistrationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiRegistrationsId>>>;

export type DeleteApiRegistrationsIdMutationError = ErrorType<unknown>;

/**
 * @summary Удаление заявки
 */
export const useDeleteApiRegistrationsId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiRegistrationsId>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteApiRegistrationsId>>, TError, { id: number }, TContext> => {
  const mutationOptions = getDeleteApiRegistrationsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Добавление заявки
 */
export const postApiRegistrations = (
  requestsRegistrationRequest: BodyType<RequestsRegistrationRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/Registrations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsRegistrationRequest,
      signal
    },
    options
  );
};

export const getPostApiRegistrationsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrations>>,
    TError,
    { data: BodyType<RequestsRegistrationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrations>>,
  TError,
  { data: BodyType<RequestsRegistrationRequest> },
  TContext
> => {
  const mutationKey = ['postApiRegistrations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrations>>,
    { data: BodyType<RequestsRegistrationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiRegistrations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRegistrations>>>;
export type PostApiRegistrationsMutationBody = BodyType<RequestsRegistrationRequest>;
export type PostApiRegistrationsMutationError = ErrorType<unknown>;

/**
 * @summary Добавление заявки
 */
export const usePostApiRegistrations = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrations>>,
      TError,
      { data: BodyType<RequestsRegistrationRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrations>>,
  TError,
  { data: BodyType<RequestsRegistrationRequest> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Подтверждение создания заявки
 */
export const putApiRegistrationsIdConfirmCreation = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Registrations/${id}/confirm-creation`, method: 'PUT' },
    options
  );
};

export const getPutApiRegistrationsIdConfirmCreationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['putApiRegistrationsIdConfirmCreation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return putApiRegistrationsIdConfirmCreation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdConfirmCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>
>;

export type PutApiRegistrationsIdConfirmCreationMutationError = ErrorType<unknown>;

/**
 * @summary Подтверждение создания заявки
 */
export const usePutApiRegistrationsIdConfirmCreation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiRegistrationsIdConfirmCreation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getPutApiRegistrationsIdConfirmCreationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Подписание заявки
 */
export const putApiRegistrationsIdSign = (
  id: number,
  putApiRegistrationsIdSignBody: BodyType<string>,
  params: PutApiRegistrationsIdSignParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Registrations/${id}/sign`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putApiRegistrationsIdSignBody,
      params
    },
    options
  );
};

export const getPutApiRegistrationsIdSignMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdSign>>,
    TError,
    { id: number; data: BodyType<string>; params: PutApiRegistrationsIdSignParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationsIdSign>>,
  TError,
  { id: number; data: BodyType<string>; params: PutApiRegistrationsIdSignParams },
  TContext
> => {
  const mutationKey = ['putApiRegistrationsIdSign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRegistrationsIdSign>>,
    { id: number; data: BodyType<string>; params: PutApiRegistrationsIdSignParams }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return putApiRegistrationsIdSign(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdSign>>
>;
export type PutApiRegistrationsIdSignMutationBody = BodyType<string>;
export type PutApiRegistrationsIdSignMutationError = ErrorType<unknown>;

/**
 * @summary Подписание заявки
 */
export const usePutApiRegistrationsIdSign = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdSign>>,
      TError,
      { id: number; data: BodyType<string>; params: PutApiRegistrationsIdSignParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiRegistrationsIdSign>>,
  TError,
  { id: number; data: BodyType<string>; params: PutApiRegistrationsIdSignParams },
  TContext
> => {
  const mutationOptions = getPutApiRegistrationsIdSignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Подписание заявки без документа
 */
export const putApiRegistrationsIdSignWoDoc = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Registrations/${id}/sign-wo-doc`, method: 'PUT' },
    options
  );
};

export const getPutApiRegistrationsIdSignWoDocMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['putApiRegistrationsIdSignWoDoc'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return putApiRegistrationsIdSignWoDoc(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdSignWoDocMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>
>;

export type PutApiRegistrationsIdSignWoDocMutationError = ErrorType<unknown>;

/**
 * @summary Подписание заявки без документа
 */
export const usePutApiRegistrationsIdSignWoDoc = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiRegistrationsIdSignWoDoc>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiRegistrationsIdSignWoDocMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Убрать подписание заявки
 */
export const putApiRegistrationsIdUnsign = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Registrations/${id}/unsign`, method: 'PUT' }, options);
};

export const getPutApiRegistrationsIdUnsignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiRegistrationsIdUnsign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return putApiRegistrationsIdUnsign(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdUnsignMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>
>;

export type PutApiRegistrationsIdUnsignMutationError = ErrorType<unknown>;

/**
 * @summary Убрать подписание заявки
 */
export const usePutApiRegistrationsIdUnsign = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiRegistrationsIdUnsign>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiRegistrationsIdUnsignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Подтверждение заявки
 */
export const putApiRegistrationsIdConfirm = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Registrations/${id}/confirm`, method: 'PUT' }, options);
};

export const getPutApiRegistrationsIdConfirmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiRegistrationsIdConfirm'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return putApiRegistrationsIdConfirm(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>
>;

export type PutApiRegistrationsIdConfirmMutationError = ErrorType<unknown>;

/**
 * @summary Подтверждение заявки
 */
export const usePutApiRegistrationsIdConfirm = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiRegistrationsIdConfirm>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiRegistrationsIdConfirmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Создать ОСИ на основе подтвержденной заявки
 */
export const postApiRegistrationsIdCreateOsi = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbOsiOSICoreTypes>(
    { url: `/api/Registrations/${id}/create-osi`, method: 'POST', signal },
    options
  );
};

export const getPostApiRegistrationsIdCreateOsiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postApiRegistrationsIdCreateOsi'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return postApiRegistrationsIdCreateOsi(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationsIdCreateOsiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>
>;

export type PostApiRegistrationsIdCreateOsiMutationError = ErrorType<unknown>;

/**
 * @summary Создать ОСИ на основе подтвержденной заявки
 */
export const usePostApiRegistrationsIdCreateOsi = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiRegistrationsIdCreateOsi>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPostApiRegistrationsIdCreateOsiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Добавление сканированного документа к заявке
 */
export const postApiRegistrationsIdDocs = (
  id: number,
  requestsAddScanDoc: BodyType<RequestsAddScanDoc>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbRegistrationDocOSICoreTypes>(
    {
      url: `/api/Registrations/${id}/docs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAddScanDoc,
      signal
    },
    options
  );
};

export const getPostApiRegistrationsIdDocsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>,
    TError,
    { id: number; data: BodyType<RequestsAddScanDoc> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>,
  TError,
  { id: number; data: BodyType<RequestsAddScanDoc> },
  TContext
> => {
  const mutationKey = ['postApiRegistrationsIdDocs'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>,
    { id: number; data: BodyType<RequestsAddScanDoc> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiRegistrationsIdDocs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationsIdDocsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>
>;
export type PostApiRegistrationsIdDocsMutationBody = BodyType<RequestsAddScanDoc>;
export type PostApiRegistrationsIdDocsMutationError = ErrorType<unknown>;

/**
 * @summary Добавление сканированного документа к заявке
 */
export const usePostApiRegistrationsIdDocs = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>,
      TError,
      { id: number; data: BodyType<RequestsAddScanDoc> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrationsIdDocs>>,
  TError,
  { id: number; data: BodyType<RequestsAddScanDoc> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationsIdDocsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить сканированные документы по заявке
 */
export const getApiRegistrationsIdDocs = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbRegistrationDocPrivateCoreLib>(
    { url: `/api/Registrations/${id}/docs`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsIdDocsQueryKey = (id: number) => {
  return [`/api/Registrations/${id}/docs`] as const;
};

export const getGetApiRegistrationsIdDocsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsIdDocsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>> = ({ signal }) =>
    getApiRegistrationsIdDocs(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsIdDocsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>>;
export type GetApiRegistrationsIdDocsQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsIdDocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdDocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdDocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить сканированные документы по заявке
 */

export function useGetApiRegistrationsIdDocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsIdDocsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить список требуемых документов для подачи заявки
 */
export const getApiRegistrationsReqdocs = (
  params?: GetApiRegistrationsReqdocsParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesRequiredDocsResponsePrivateCoreLib>(
    { url: `/api/Registrations/reqdocs`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiRegistrationsReqdocsQueryKey = (params?: GetApiRegistrationsReqdocsParams) => {
  return [`/api/Registrations/reqdocs`, ...(params ? [params] : [])] as const;
};

export const getGetApiRegistrationsReqdocsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiRegistrationsReqdocsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsReqdocsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>> = ({ signal }) =>
    getApiRegistrationsReqdocs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsReqdocsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>>;
export type GetApiRegistrationsReqdocsQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsReqdocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetApiRegistrationsReqdocsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsReqdocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiRegistrationsReqdocsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsReqdocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiRegistrationsReqdocsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список требуемых документов для подачи заявки
 */

export function useGetApiRegistrationsReqdocs<
  TData = Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>,
  TError = ErrorType<unknown>
>(
  params?: GetApiRegistrationsReqdocsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsReqdocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsReqdocsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Удалить сканированный документ у заявки
 */
export const deleteApiRegistrationsIdDocsDocId = (
  id: number,
  docId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Registrations/${id}/docs/${docId}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiRegistrationsIdDocsDocIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>,
    TError,
    { id: number; docId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationKey = ['deleteApiRegistrationsIdDocsDocId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>,
    { id: number; docId: number }
  > = (props) => {
    const { id, docId } = props ?? {};

    return deleteApiRegistrationsIdDocsDocId(id, docId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRegistrationsIdDocsDocIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>
>;

export type DeleteApiRegistrationsIdDocsDocIdMutationError = ErrorType<unknown>;

/**
 * @summary Удалить сканированный документ у заявки
 */
export const useDeleteApiRegistrationsIdDocsDocId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>,
      TError,
      { id: number; docId: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiRegistrationsIdDocsDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationOptions = getDeleteApiRegistrationsIdDocsDocIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Счета данной заявки
 */
export const getApiRegistrationsIdAccounts = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbRegistrationAccountPrivateCoreLib>(
    { url: `/api/Registrations/${id}/accounts`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsIdAccountsQueryKey = (id: number) => {
  return [`/api/Registrations/${id}/accounts`] as const;
};

export const getGetApiRegistrationsIdAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsIdAccountsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>> = ({ signal }) =>
    getApiRegistrationsIdAccounts(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsIdAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>
>;
export type GetApiRegistrationsIdAccountsQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsIdAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Счета данной заявки
 */

export function useGetApiRegistrationsIdAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsIdAccountsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Установить шаг визарда
 */
export const putApiRegistrationsIdWizardStep = (
  id: number,
  putApiRegistrationsIdWizardStepBody: BodyType<string>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Registrations/${id}/wizard-step`,
      method: 'PUT',
      headers: { 'Content-Type': 'text/plain' },
      data: putApiRegistrationsIdWizardStepBody
    },
    options
  );
};

export const getPutApiRegistrationsIdWizardStepMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>,
    TError,
    { id: number; data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['putApiRegistrationsIdWizardStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>,
    { id: number; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiRegistrationsIdWizardStep(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationsIdWizardStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>
>;
export type PutApiRegistrationsIdWizardStepMutationBody = BodyType<string>;
export type PutApiRegistrationsIdWizardStepMutationError = ErrorType<unknown>;

/**
 * @summary Установить шаг визарда
 */
export const usePutApiRegistrationsIdWizardStep = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>,
      TError,
      { id: number; data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiRegistrationsIdWizardStep>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getPutApiRegistrationsIdWizardStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить группы услуг целевой ОСИ с текущими привязанными счетами.
Используется в wizard СФУ (шаг выбора счетов) и в форме оператора.
EXTERNAL-счета исключены защитным фильтром.
 */
export const getApiRegistrationsIdGroupsWithCurrentAccounts = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsResponsesGroupWithAccountResponsePrivateCoreLib>(
    { url: `/api/Registrations/${id}/groups-with-current-accounts`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsIdGroupsWithCurrentAccountsQueryKey = (id: number) => {
  return [`/api/Registrations/${id}/groups-with-current-accounts`] as const;
};

export const getGetApiRegistrationsIdGroupsWithCurrentAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsIdGroupsWithCurrentAccountsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>> = ({
    signal
  }) => getApiRegistrationsIdGroupsWithCurrentAccounts(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsIdGroupsWithCurrentAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>
>;
export type GetApiRegistrationsIdGroupsWithCurrentAccountsQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsIdGroupsWithCurrentAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdGroupsWithCurrentAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdGroupsWithCurrentAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить группы услуг целевой ОСИ с текущими привязанными счетами.
Используется в wizard СФУ (шаг выбора счетов) и в форме оператора.
EXTERNAL-счета исключены защитным фильтром.
 */

export function useGetApiRegistrationsIdGroupsWithCurrentAccounts<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdGroupsWithCurrentAccounts>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsIdGroupsWithCurrentAccountsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить заявочные счета с привязанными сканами реквизитов (DocTypeCode="IBAN_INFO").
Используется оператором при рассмотрении заявки СФУ.
ScanId передаётся фронту — для получения файла: GET /api/Scans/{ScanId}.
 */
export const getApiRegistrationsIdAccountsWithScans = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsResponsesAccountWithScanResponsePrivateCoreLib>(
    { url: `/api/Registrations/${id}/accounts-with-scans`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationsIdAccountsWithScansQueryKey = (id: number) => {
  return [`/api/Registrations/${id}/accounts-with-scans`] as const;
};

export const getGetApiRegistrationsIdAccountsWithScansQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationsIdAccountsWithScansQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>> = ({ signal }) =>
    getApiRegistrationsIdAccountsWithScans(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationsIdAccountsWithScansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>
>;
export type GetApiRegistrationsIdAccountsWithScansQueryError = ErrorType<unknown>;

export function useGetApiRegistrationsIdAccountsWithScans<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdAccountsWithScans<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationsIdAccountsWithScans<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить заявочные счета с привязанными сканами реквизитов (DocTypeCode="IBAN_INFO").
Используется оператором при рассмотрении заявки СФУ.
ScanId передаётся фронту — для получения файла: GET /api/Scans/{ScanId}.
 */

export function useGetApiRegistrationsIdAccountsWithScans<
  TData = Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationsIdAccountsWithScans>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationsIdAccountsWithScansQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary SFU: атомарно создать счёт заявки и скан реквизитов (DocTypeCode="IBAN_INFO") в одной транзакции.
Заменяет двухшаговый flow POST /api/RegistrationAccounts + POST /{id}/doc, который для СФУ-сценария
не работал из-за CheckCanAdd на ServiceGroupId != null. AccountTypeCode определяется группой услуг.
 */
export const postApiRegistrationsRegistrationIdSfuAccounts = (
  registrationId: number,
  requestsSfuAccountRequest: BodyType<RequestsSfuAccountRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesSfuAccountResponseOSICoreTypes>(
    {
      url: `/api/Registrations/${registrationId}/sfu-accounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsSfuAccountRequest,
      signal
    },
    options
  );
};

export const getPostApiRegistrationsRegistrationIdSfuAccountsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>,
    TError,
    { registrationId: number; data: BodyType<RequestsSfuAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>,
  TError,
  { registrationId: number; data: BodyType<RequestsSfuAccountRequest> },
  TContext
> => {
  const mutationKey = ['postApiRegistrationsRegistrationIdSfuAccounts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>,
    { registrationId: number; data: BodyType<RequestsSfuAccountRequest> }
  > = (props) => {
    const { registrationId, data } = props ?? {};

    return postApiRegistrationsRegistrationIdSfuAccounts(registrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationsRegistrationIdSfuAccountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>
>;
export type PostApiRegistrationsRegistrationIdSfuAccountsMutationBody = BodyType<RequestsSfuAccountRequest>;
export type PostApiRegistrationsRegistrationIdSfuAccountsMutationError = ErrorType<unknown>;

/**
 * @summary SFU: атомарно создать счёт заявки и скан реквизитов (DocTypeCode="IBAN_INFO") в одной транзакции.
Заменяет двухшаговый flow POST /api/RegistrationAccounts + POST /{id}/doc, который для СФУ-сценария
не работал из-за CheckCanAdd на ServiceGroupId != null. AccountTypeCode определяется группой услуг.
 */
export const usePostApiRegistrationsRegistrationIdSfuAccounts = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>,
      TError,
      { registrationId: number; data: BodyType<RequestsSfuAccountRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrationsRegistrationIdSfuAccounts>>,
  TError,
  { registrationId: number; data: BodyType<RequestsSfuAccountRequest> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationsRegistrationIdSfuAccountsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
